import { useEffect } from 'react';

import { reportingFormsStore } from '@stores/reportingFormsStore';
import { reportingTreeStore } from '@stores/reportingTreeStore';

export const useIsTreeOpenInNewTab = (): void => {
  useEffect(() => {
    const { setOrganizationCode, setStateTree, updateReportingTree } = reportingTreeStore;
    const { setFullSizeInfo, addBreadcrumbs, addPage } = reportingFormsStore;

    const config = JSON.parse(localStorage.getItem('treeInNewTab') ?? '{}');

    if (config.organizationCode) setOrganizationCode(config.organizationCode);
    if (config.reportingTree) updateReportingTree(config.reportingTree);
    if (config.stateTree) setStateTree(config.stateTree);
    if (config.fullSizeInfo) setFullSizeInfo(config.fullSizeInfo);
    if (config.breadcrumbs) addBreadcrumbs(config.breadcrumbs, true);
    if (config.pagesParam) addPage(config.pagesParam);

    localStorage.removeItem('treeInNewTab');
  }, []);
};
